import React from 'react';
import PropTypes from 'prop-types';
import s from './NewStoryCard.scss';

import { CARD_27, CARD_27_1, CARD_29 } from './cards';

function RatingComponent({
  cardType,
  criticRating,
  userRating,
  userCount,
  onCriticRatingClick,
  onUserRatingClick,
}) {
  if (cardType === CARD_27 || cardType === CARD_27_1) {
    return (
      <div className={s.innerWrap}>
        <div className={`${s.ratingWrap} ${s.ratingReview}`}>
          {criticRating && (
            <div
              className={s.ratings}
              onClick={e => {
                if (typeof onCriticRatingClick === 'function') {
                  e.preventDefault();
                  e.stopPropagation();
                  onCriticRatingClick();
                }
              }}
            >
              <p className={s.ratingsGiven}>
                {criticRating} <span className={s.starIcon} />
              </p>
              <p className={s.ratingsBy}>Critic&apos;s Rating</p>
            </div>
          )}
          {userRating && (
            <div
              className={s.ratings}
              onClick={e => {
                if (typeof onUserRatingClick === 'function') {
                  e.preventDefault();
                  e.stopPropagation();
                  onUserRatingClick();
                }
              }}
            >
              <p className={s.ratingsGiven}>
                {userRating} <span className={s.starIcon} />
              </p>
              <p className={s.ratingsBy}>
                Users&apos; Rating {userCount ? `(${userCount})` : ''}
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (cardType === CARD_29 && criticRating) {
    return (
      <div className={`${s.ratingWrap} ${s.ratingReview}`}>
        <div className={s.ratings}>
          <p className={s.ratingsBy}>Critic&apos;s Rating: </p>
          <p className={s.ratingsGiven}>
            {criticRating} <span className={s.starIcon} />
          </p>
        </div>
      </div>
    );
  }

  return null;
}

RatingComponent.propTypes = {
  cardType: PropTypes.string,
  criticRating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  userRating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  userCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onCriticRatingClick: PropTypes.func,
  onUserRatingClick: PropTypes.func,
};

RatingComponent.defaultProps = {
  cardType: '',
  criticRating: '',
  userRating: '',
  userCount: '',
  onCriticRatingClick: () => {},
  onUserRatingClick: () => {},
};

export default RatingComponent;
